module.exports = "/static/Images/images/Satisfied.png";